import script from "./SguDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SguDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SguDashboard.vue?vue&type=style&index=0&id=31550484&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31550484"]])

export default __exports__